import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@chakra-ui/react";
import parse from 'html-react-parser';
// Main components
import MainLayout from "../../../components/main/layout/layout";
// Maintenance components
import MaintenanceDetail from "../../../components/maintenance/detail/detail";
// Components
import FilesList from "../../../components/filesList/filesList";
// Actions
import * as mainActions from "../../../redux/actions/main";
import * as liveActions from "../../../redux/actions/live";
// Utils
import { 
  formatDateToMadridTime, 
  formatDaysOfWeek,
} from "../../../utils/formatters";
// Styles
import "./detail.css";

const LiveDetail = () => {
  const dispatch = useDispatch();
  // States
  const [isLoading, setIsLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  // Selectors
  const currentPage = useSelector((state) => state.mainReducer.currentPage); 
  const user = useSelector(state => state.authReducer.user);

  // Set constants
  const page = "live";
  const primaryName = !!detail && !!detail.title ? detail.title : ``;
  const itemNameSingular = "Directe";

  // Get id from url
  const { id: paramId } = useParams();
  const id = parseInt(paramId);
  // console.log('id', id);
  
  useEffect(() => {
    if (!!currentPage) return;
    // Set active page
    dispatch(mainActions.setCurrentPage(page));
    // Set initial breadscrum
    const pathKey = 'detail';
    const path = `${page}/${pathKey}/${id}`;
    dispatch(mainActions.setBreadscrum(page, [{ path, pathKey, primaryValue: id, primaryName, itemNameSingular, }])); 
  }, []);

  const renderDetail = () => {
    // console.log('renderDetail > detail', detail);
    if (!detail) return null;
    return (
      <div className="live-detail-cards-wrapper">
        {renderMainCard()}
        {renderFilesList()}
      </div>
    );
  };

  const renderMainCard = () => {
    const days_of_week = detail.days_of_week
                    .split("|")
                    .filter(Boolean) // Elimina elements buits
                    .map(formatDaysOfWeek) // Aplica formatDaysOfWeek
                    .join(", ");    
    return (
      <div className="maintenance-detail-card live-detail-card">
        <div className="title maintenance-detail-title">
          {detail.title}
        </div>
        {renderField("Id", detail.id)}
        {renderField("Títol", detail.title)}
        {renderField("Sub-títol", detail.subtitle)}
        {renderField("Descripció", detail.description)}
        {renderField("Hora inici", detail.start_time)}
        {renderField("Hora final", detail.end_time)}
        {renderField("Dies disponibles", days_of_week)}
        {renderField("Habilitat", detail.enabled ? "SI" : "NO")}    
        <Box h={"20px"}></Box>            
        {renderField("Data de creació", formatDateToMadridTime(detail.creation_date))}
        {renderField("Usuari de creació", detail.creation_user)}
        {renderField("Data última modificació", formatDateToMadridTime(detail.last_modification_date))}
        {renderField("Usuari última modificació", detail.last_modification_user)}
      </div>
    );
  };

  const renderFilesList = () => {
    const url_image_1 = !!detail.url_image_1 ? parse(`<a href="${detail.url_image_1}" target="_blank">${detail.url_image_1}</a>`) : "";
    const url_image_2 = !!detail.url_image_2 ? parse(`<a href="${detail.url_image_2}" target="_blank">${detail.url_image_2}</a>`) : "";
    return (
      <div className="maintenance-detail-filelist-card">
        <Box className="maintenance-detail-label">
          Imatge principal / Portada
        </Box>
        {!!url_image_1 && (
          <Box mt="3px" className="maintenance-detail-field">
            {url_image_1}
          </Box>       
        )}             
        <FilesList
          type={"live"}
          id={id}
          id2={"1"}
          setIsLoading={setIsLoading}
          label={""}
        />
        <Box className="maintenance-detail-label">
          Imatge secundaria
        </Box>
        {!!url_image_2 && (
          <Box mt="3px" className="maintenance-detail-field">
            {url_image_2}
          </Box>       
        )}           
        <FilesList
          type={"live"}
          id={id}
          id2={"2"}
          setIsLoading={setIsLoading}
          label={""}
        />        
      </div>
    );
  };

  const renderField = (label, value) => {
    return (
      <div className="maintenance-detail-field-parent">
        <Box className="maintenance-detail-label" w={"220px"}>
          {label}
        </Box>    
        <Box className="maintenance-detail-field">
          {value}
        </Box>         
      </div>
    );
  };

  return (
    <MainLayout isLoading={isLoading} setIsLoading={setIsLoading}>
      <div id="live-detail-content">
        <MaintenanceDetail 
          primaryValue={id}
          primaryName={primaryName}
          menuConfig={{
            buttonEdit: { visible: !!user && user.grants.live },
            buttonDelete: { visible: !!user && user.grants.live },
          }}
          itemNameSingular={itemNameSingular}
          itemIsMale={true}
          actions={liveActions} 
          setIsLoading={setIsLoading}
          renderDetail={renderDetail}
          setDetail={setDetail}
          page={"live"}
        />
      </div>
    </MainLayout>
  );
};

export default LiveDetail;
